module.exports = __webpack_public_path__ + "img/ic-usb-gradient-64-px.3cc63554.svg";